import { finish, error } from '../../../modules/events/actions/update';
import { update as updateSport } from '../../../modules/sports/actions/update';
import { update as updateCompetition } from '../../../modules/competitions/actions/update';
import { bulk as bulkUpdateParticipants } from '../../../modules/participants/actions/update';
import { finish as finishOpen } from '../../../modules/events/actions/open'

import api from '../../../api';

export function request(dispatch, { id, data }) {
    api.patch('/events/' + id, data).then(
        (event) => {
            if(event.hasOwnProperty('events')) {
                dispatch(finishOpen(id, event))
            }else{
                dispatch(updateSport(event.sport.id, event.sport));
                dispatch(updateCompetition(event.competition.id, event.competition));
                dispatch(bulkUpdateParticipants(event.participants.map(p => p.participant)));
                event.sport = event.sport.id;
                event.competition = event.competition.id;
                event.participants = event.participants.map(participant => {
                    return {
                        id: participant.participant.id,
                        role: participant.role
                    };
                });

                dispatch(finish(id, event));
            }
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
